import { AbstractMapLayerProviderList } from 'app/config/AbstractMapLayerProviderList';
import { ImsFeatureLayerProvider } from 'app/config/ImsFeatureLayerProvider';

export class ImsFeatureLayerProviderList extends AbstractMapLayerProviderList<ImsFeatureLayerProvider> {
    constructor(providers: ImsFeatureLayerProvider[] = []) {
        super(providers);
    }

    clone(): this {
        return new ImsFeatureLayerProviderList(this._providers.map((p) => p.clone())) as any;
    }
}
